// utils/phoneFormatter.js
import { parsePhoneNumber, AsYouType } from 'libphonenumber-js';

export function formatPhoneDisplay(phone, countryHint = 'US') {
  if (!phone) return '';

  const str = phone.toString();

  // Try strict parsing first for valid numbers
  try {
    const phoneNumber = str.startsWith('+')
      ? parsePhoneNumber(str)
      : parsePhoneNumber(str, countryHint);

    if (phoneNumber && phoneNumber.isValid()) {
      return phoneNumber.formatNational(); // (415) 940-5915
    }
  } catch (error) {
    // Fall through to AsYouType
  }

  // Use AsYouType for partial/invalid numbers — still applies formatting
  try {
    const formatter = new AsYouType(countryHint);
    const formatted = formatter.input(str);
    if (formatted) return formatted;
  } catch (error) {
    // Return original if can't format
  }

  return str;
}

// Reads the country out of a stored E.164 value ("+32473444416" -> BE) so an
// input can open under the number's own flag instead of the venue's default.
// Returns null for empty values, values without a "+" prefix, and numbers
// libphonenumber cannot assign to a country; callers then keep their default.
export function parseStoredPhone(phone) {
  if (!phone) return null;

  const str = phone.toString().trim();
  if (!str.startsWith('+')) return null;

  try {
    const phoneNumber = parsePhoneNumber(str);
    if (phoneNumber && phoneNumber.country) {
      return {
        country: phoneNumber.country,
        nationalNumber: phoneNumber.nationalNumber
      };
    }
  } catch (error) {
    // Not parseable; caller keeps its default country
  }

  return null;
}

export function toE164(phone, countryHint = 'US') {
  if (!phone) return '';

  try {
    const phoneNumber = phone.toString().startsWith('+')
      ? parsePhoneNumber(phone)
      : parsePhoneNumber(phone, countryHint);

    if (phoneNumber && phoneNumber.isValid()) {
      return phoneNumber.format('E.164'); // +14159405915
    }
  } catch (error) {
    // Return original if can't parse
  }

  return phone;
}
